import { ref } from 'vue';
import { EN_SPACE_TYPE } from '../enums/spaceTypeEnum';
import { esHelper, IFindByConditionResponse } from '/@/utils/http/es_utils/es_helper';
import { defHttp } from '../../../../utils/http/axios';

const INIT_PERSON_ISPACE_DEMO_PROJECT = '/doMistServer/space/initProject';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IPersonalInfo {}

const personalInfo = ref<IFindByConditionResponse & IPersonalInfo>();

export const usePersonalSpace = () => {
  return {
    personalInfo,
    createPersonalSpace,
  };
};

export const createPersonalSpace = async () => {
  if (!personalInfo.value) {
    const res = await esHelper.findByCondition<IPersonalInfo>(
      {
        includeAllChildren: false,
        props: {
          spaceType: EN_SPACE_TYPE.个人空间,
        },
        tags: ['space'],
        force: false,
        // userId: userStore.getUserInfo.id as string,
      },
      { tenantId: '0' }
    );
    personalInfo.value = res.result[0];
  }
};

/**
 *
 * @param pId 初始化demo项目
 * @returns
 */
export const initPersonISpaceDemoProject = async (pId) => {
  return defHttp.post({
    url: INIT_PERSON_ISPACE_DEMO_PROJECT,
    data: {
      pid: pId,
    },
    params: {
      tenantId: 0,
    },
  });
};
